/**
 * 最大钉数量
 */
export const MAX_PINNED_LENGTH = 6;
